import { render, staticRenderFns } from "./LLoading.vue?vue&type=template&id=e3228d72&scoped=true"
import script from "./LLoading.vue?vue&type=script&lang=js"
export * from "./LLoading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3228d72",
  null
  
)

export default component.exports